import { Component} from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Location } from '@angular/common';
import { RoleLovComponent } from '../role-lov/role-lov.component';
import { ProfileLovComponent } from '../../profile/profile-lov/profile-lov.component';
import { PersonLovComponent } from '../../person/person-lov/person-lov.component';
import { BasePage2 } from 'src/app/tools/abstract-classes/base-page2';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { Role } from 'src/app/assabil-kernel/models/entities/master-data/role-entity';
import { MasterDataService } from 'src/app/assabil-kernel/services/master-data-service';
import { Field } from 'src/app/tools/models/dtos/field';
import { GeoAreaLovComponent } from '../../../control-tables/geo-area-lov/geo-area-lov.component';
import { TokenSerieLovComponent } from '../../../control-tables/token-serie-lov/token-serie-lov.component';
import { DeviceLovComponent } from '../../../control-tables/device-lov/device-lov.component';
import { BranchLovComponent } from '../../../control-tables/branch/branch-lov/branch-lov.component';
import { ItineraryLovComponent } from '../../partner/itinerary-lov/itinerary-lov.component';
import { WarehouseLovComponent } from '../../../control-tables/branch/warehouse-lov/warehouse-lov.component';

@Component({
    selector: 'role-list',
    templateUrl: './role-list.component.html',
    styleUrls: ['./role-list.component.scss']
})


export class RoleListComponent extends BasePage2<Role> {

    roles: Role[] = [];
    code: string;
    name: string;
    branchCode : string;


    constructor(
        protected toastr            : ToastrService,
        protected masterDataService : MasterDataService,
        protected router            : Router,
        protected baseService       : BaseService,
        protected leanUtilsService  : LeanUtilsService, 
        protected location          : Location) {
         super(toastr, router, baseService, leanUtilsService, location);

         this.entityName = 'role';
    }

   
//----------------------------------------------------------------------
ngAfterViewInit(): void {
    super.ngAfterViewInit();
      this.setChildFields();
  }
  //----------------------------------------------------------------------
  
  //----------------------------------------------------------------------
  setChildFields(){
        this.baseService.fieldsGet('roleItinerary').then(result => {
              this.childFields = result.listFields;
  
              this.childFields.forEach(field => {
                  if (field.prop == 'itinerary') {
                    field.modal = ItineraryLovComponent;
                    field.subProp = 'name';
                  }
              })
  
        }) 
    }
  //----------------------------------------------------------------------
  
//----------------------------------------------------------------------
getRows(): Role[] {
    return this.roles;
}
//----------------------------------------------------------------------

     
//----------------------------------------------------------------------
new(){
    let role : Role = new Role();
    role.inserted   = true;
    role.edit       = true;
    this.selectedRow = role;
}
//----------------------------------------------------------------------
 
//----------------------------------------------------------------------
selectRow(role : Role){
    this.masterDataService.roleGet(role.roleCode).then(result => {
        this.selectedRow = result;
    })
  }
//----------------------------------------------------------------------
  

//----------------------------------------------------------------------
loadData() {
        this.masterDataService.rolesGet(this.code, this.name, this.branchCode).then(result => {
            this.roles = result;
        })
    }
//----------------------------------------------------------------------

    
//----------------------------------------------------------------------
enrichField(field : Field){

    if (field.prop == 'profile') {    
        field.modal = ProfileLovComponent;
        field.subProp = 'name';
        return;
    }
    if (field.prop == 'upRole') {
        field.modal = RoleLovComponent;
        field.subProp = 'name';
        return;
    }
    if (field.prop == 'person') {
        field.modal = PersonLovComponent;
        field.subProp = 'name';
        return;
    }
    if (field.prop == 'branch') {
        field.modal = BranchLovComponent;
        field.subProp = 'name';
        return;
    }
    if (field.prop == 'geoArea') {
        field.modal = GeoAreaLovComponent;
        field.subProp = 'name';
        return;
    }

    if (field.prop == 'warehouse') {
        field.modal = WarehouseLovComponent;
        field.subProp = 'name';
        return;
    }
    if (field.prop == 'feededFromWarehouse') {
        field.modal = WarehouseLovComponent;
        field.subProp = 'name';
        return;
    }    

    if (field.prop == 'device') {
        field.modal = DeviceLovComponent;
        field.subProp = 'deviceSerialNumber';
        return;
    }
    if (field.prop == 'tokenSerie') {
        field.modal = TokenSerieLovComponent;
        field.subProp = 'name';
        return;
    }
    
}
//----------------------------------------------------------------------


}
